import { Paragraph, StyledAlert } from "App/global-style";
import React, { useState } from "react";

import { AlertType } from "Components/Form/Alert";
import { TextManager } from "Components/TextContext";
import { componentClicked } from "Store/analytics/analyticsSlice";
import { useMarketingConsent } from "Store/consent/consentHooks";
import { updateMarketingConsent } from "Store/consent/marketingConsentSlice";
import { buttonConsentTrackId } from "Utils/analytics";
import { useDispatch } from "react-redux";
import { ConsentButton } from "./consentStyled";

export const MarketingConsent = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { consented, error } = useMarketingConsent();
  const [clicked, setClicked] = useState(false);
  const { getText } = TextManager;

  const consentText = getText("legal.marketingconsent.consenttext");
  const consentButtonTrackId = consented
    ? "marketing-not-consented"
    : "marketing-consented";
  const consentLinkText = consented
    ? getText("legal.marketingconsent.donotconsentlink")
    : getText("legal.marketingconsent.consentlink");
  const errorTitle = consented
    ? getText("legal.marketingconsent.donotconsenterrortitle")
    : getText("legal.marketingconsent.consenterrortitle");
  const errorText = consented
    ? getText("legal.marketingconsent.donotconsenterrordescription")
    : getText("legal.marketingconsent.consenterrordescription");

  const handleConsent = (): void => {
    setClicked(true);
    dispatch(componentClicked(buttonConsentTrackId(consentButtonTrackId)));
    dispatch(updateMarketingConsent(consentText));
  };

  return (
    <>
      <Paragraph>
        {consentText}{" "}
        {
          <ConsentButton
            data-trackid={buttonConsentTrackId(consentButtonTrackId)}
            onClick={handleConsent}
            type="button"
          >
            {consentLinkText}
          </ConsentButton>
        }
      </Paragraph>
      {clicked && error && (
        <StyledAlert
          fluid
          description={errorText}
          type="error"
          title={errorTitle}
          alertId="consent-alert"
          alertType={AlertType.SYSTEM_ERROR_ALERT}
        />
      )}
    </>
  );
};
